import {DeliveryState} from "../../../type/delivery-state";
import {Delivery} from "../../../../types/delivery/delivery";

interface Action {
    type: string;
    payload: {
        deliveries: Delivery[];
    };
}

export const addCachedDeliveriesDispatch = (
    state: DeliveryState,
    action: Action
) => {
    const {deliveries} = action.payload;

    const updatedDeliveries = state.cachedUpdateDeliveries.filter(
        (existingDelivery) =>
            !deliveries.some((newDelivery) => newDelivery.id === existingDelivery.id)
    );

    state.cachedUpdateDeliveries = [...updatedDeliveries, ...deliveries];
};
